(function ($) {
	// Tabs
	$('.tabs-wrap').each(function(){
		var $this = $(this);
		var $tabsWrap = $this.find('.tabs');
		var $content = $this.find('.tabs-content');

		$tabsWrap.find('a').each(function () {
			var $this = $(this);
			var tab_id = $this.attr('href');
			if ($this.closest('li').hasClass('tab-current')) $(tab_id).addClass('tab-current');
			$this.on('click', function (e) {
				e.preventDefault();

				$tabsWrap.find('li').removeClass('tab-current');
				$content.removeClass('tab-current');

				$this.closest('li').addClass('tab-current');
				$(tab_id).addClass('tab-current');
			})
		});
		
	});
})(jQuery);
